import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<WithTranslation, State> {
  constructor(props: WithTranslation) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <h1>{this.props.t('errors.boundary.message')}</h1>;
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
